var map = {
	"./UVA.png": 521,
	"./au_square.png": 99,
	"./dcamp.png": 80,
	"./headshot.png": 333,
	"./huggingface-icon.svg": 63,
	"./mlcycle.png": 636,
	"./numpy-icon.svg": 921,
	"./pandas-icon.svg": 758,
	"./pytorch-icon.svg": 850,
	"./scikit-learn-icon.svg": 935,
	"./tensorflow-icon.svg": 146
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 811;